








































































    import {Component, Vue} from 'vue-property-decorator';
    import common from "../../../assets/js/common";
    import popup from "../../../theme/component/popup/popup.vue";
    @Component({
        components: { popup }
    })
    export default class RedPacket extends Vue {
        goddlist:any = []
		show:boolean = false
		btnDisabled: boolean = false
		activityNo:any = ''
		activityType:any = ''
		bmTip:any = false
        // Cancel:any = 0
        // meet:any = 0
        totalDiscountAmount: any = 0 //累计核销总金额
        totalBonusAmount: any = 0 //累计获得奖励金
        discountAmount: any = 0; //核销红包金额
        bonusAmount: any = 0 //核销奖励金金额
        public pageNo:any = 1
        customAttribute:any = []
        finished:any = false
        text: any = {
            text: '活动期间总核销累计金额。',
            content: ''
        }
        showpopup: boolean = false
        list() {
            let data: any = {
                  pageNo: this.pageNo
			}
            this.fetch({ url: '/orderactivity/api/largeItems/actListing', data})
                .then((res: any) => {
                    this.totalDiscountAmount = Number(res.totalDiscountAmount).toFixed(2)
                    this.totalBonusAmount = Number(res.totalBonusAmount).toFixed(2)
                    this.discountAmount = Number(res.discountAmount).toFixed(2)
                    this.bonusAmount = Number(res.bonusAmount).toFixed(2)
                    let list = res.listingMap;
                    if (!res || !list || !list.length) {
                        this.finished = true;
                        this.goddlist = [];
                        return;
                    }
                    if (this.pageNo === res.totalPages) {
                        this.finished = true;
                    } else {
                        this.pageNo++;
                    }
                    this.goddlist = this.goddlist.concat(list);
                })
        }
        view() { // 加载更多
            this.list()
        }
        button(item:any){ // 跳转
            let vpszone:any = common.getCookie("vps_zone") || common.getCookie("ul_zid");
            vpszone = vpszone.split('#')[0];
            window.location.href = 'https://wholesale-static' + process.env.VUE_APP_URI_DOMAIN+ '/staticZone/item/viewItem/' + vpszone + '/' + item.listId
        }
        verify() { // 核销
        this.text.text = '活动期间总核销累计金额。'
        this.text.content = ""
        this.showpopup = true
        }
        reward() { // 奖励金规则
            this.text.text = '奖励金获取规则'
            this.text.content = "<div>累计核销金额<20时， 单笔核销获得奖励金=单笔核销红包金额x<span class='color'>0.5倍</span></div><br/>累计核销金额≥20时， 单笔核销获得奖励金=单笔核销红包金额x<span class='color'>1倍</span>"
            this.showpopup = true
        }
        envelope() {// 红包规则
            this.text.text = '红包使用规则'
            this.text.content = "<div>掌柜进货使用按照核销红包<span class='color'>1:20</span>比例抵扣， 奖励金享受额外减免。<br/>例1.当前奖励金获取倍数为0.5倍时，进货满100元可抵扣5元核销红包+2.5元奖励金；进货满200元可抵扣10元核销红包+5元奖励金。</div><br/>例2.当前奖励金获取倍数为1倍时，进货满100元可抵扣5元核销红包+5元奖励金；进货满200元可抵扣10元核销红包+10元奖励金。m 以此类推~"
            this.showpopup = true
        }
        getQueryString = () => {
		let url = window.location.href;
		let data = url.split("?");
		if (data.length > 1) {
			let arr = data[1].split("&");
			let rest:any = {};
			for (let i = 0; i < arr.length; i++) {
				rest[arr[i].split("=")[0]] = decodeURI(
					arr[i].split("=")[1]
				);
			}
			return rest;
		} else {
			return {};
		}
	}
	queryActivities() {
		let activity = this.getQueryString()
		const { activityId, activityType } = activity
		// console.log('activity',activity)
		this.activityNo = activityId
		this.activityType = activityType
    const data = {
			activityNo: this.activityNo,
      activityType: this.activityType,
      channel: '1',
			status: '1',
			callbackQuery: 'jsonpCallback'
    };
    this.$jsonp(`//vps${window.domain}/vpsOnlinePayService/vpsPay/findVillagePostalActivities`, data).then((res: any) =>{
			console.log('大单品查询报名', res)
			const {returnCode, activityList, returnMessage} = res
			if(returnCode == '0000') {
				if(activityList != null && activityList.length) {
					this.btnDisabled = true
				}
			} else {
				this.$message({ message: returnMessage})
			}
		})
	}
	OnsgunUp(){
		const data = {
			activityNo: this.activityNo,
			activityType: this.activityType,
			channel: '1',
			activityName: '',
			callbackQuery: 'jsonpCallback'
        };
         this.$jsonp(`//vps${window.domain}/vpsOnlinePayService/vpsPay/saveVillagePostalActivities`, data).then((res: any) =>{
			console.log('报名', res)
			if(res.returnCode == '0000') {
				this.btnDisabled = true
				this.bmTip = true
			} else if(res.returnCode == '8888' || res.returnCode == '9999'){
				this.$message({type: 'error', message: res.returnMessage})
			}
		})
	}
	created() { 
		this.list()
        this.queryActivities()
        this.getRecommondRule()
    }
    // 获取广告推荐位信息
    getRecommondRule(){
        let data:any = {
            sectionKeys: "youlebuy_offline_member",
            restype:'2002',
            callbackQuery: 'jsoncallback'
        }
        this.$jsonp(`//search${window.domain}/api/recommend`, data).then((res: any) =>{
			let ruleObj = JSON.parse(res['youlebuy_offline_member'][0].customAttribute) || {}
            let ruleArr:any = []
            let newArr:any = []
            if(ruleObj){
                Object.keys(ruleObj).forEach((item) => {
                    ruleArr.push(Number(item.replace('rule','')))
                })
                newArr = ruleArr.sort((a:any,b:any)=>{return a-b})
                for(let i = 1; i < newArr.length + 1; i++){
                    this.customAttribute.push(ruleObj["rule"+i])
                }
            } 
		})
    }
}
